import { MessageBus } from '@setplex/mqbw'
import { mq as playerMq } from '@setplex/pureya'

/**
 * Global singleton message bus for tria
 */
export const mq = new MessageBus('tria')
globalThis.__MQ__ = mq

// player bus mount point
export const PLAYER = 'player'

// mount player bus to allow bidirectional messaging
mq.mount(PLAYER, playerMq)
